import React, { useEffect, useState } from 'react';
import { Button, IconCircleCheck, IconWand } from 'gatorcomponents';
import * as Styles from './LogoBuilderHandler.styles';
import useLocale from '@/hooks/useLocale';
import { ModalLogoGeneration, ModalPaidPlan, LogoBuilderSuccessModal } from './components';
import { MODALS, PLANS } from './logoBuilder.types';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { logoBuilderAnalytics } from '@/analytics/logoBuilder';
import { isBRServer } from '@/utils/Validators/validation';

const LogoBuilderHandler = () => {
  const { logoBuilder: logoBuilderLocale, routes: routesLocale } = useLocale();
  const [modalToShow, setModalToShow] = useState(undefined);
  const [selectedPaidPlan, setSelectedPaidPlan] = useState(false);
  const { logoGenerated } = useSelector(state => state.logoBuilder);
  const history = useHistory();
  const { available: logoBuilderAvailable } = useSelector(state => state.logoBuilder);

  useEffect(() => {
    if (!(logoBuilderAvailable && isBRServer)) {
      history.push(routesLocale.sites);
    }
  }, [logoBuilderAvailable, history, routesLocale.sites]);

  const logoBuilderSuccessModalProps = () => {
    const onClose = () => {
      history.push(routesLocale.sites);
      setModalToShow(undefined);
    };

    return ({
      onClose,
    });
  };

  const modalLogoGenerationProps = () => ({
    selectedPaidPlan,
    setModalToShow,
  });

  const handlePlanSelection = (plan) => {
    if (plan === PLANS.FREE) {
      setModalToShow(MODALS.LOGO_GENERATION);
      logoBuilderAnalytics.planSelectionContinueFree();
    }

    if (plan === PLANS.PAID) {
      setModalToShow(MODALS.PAID_PLAN);
      logoBuilderAnalytics.planSelectionStartNow();
    }
  };

  return (
    <Styles.Container>
      <Styles.PageTitle>
        <IconWand color="primaryMedium" size="lg" />
        {logoBuilderLocale.logoBuilder}
        <Styles.BetaTag>{logoBuilderLocale.beta}</Styles.BetaTag>
      </Styles.PageTitle>

      <Styles.Title>{logoBuilderLocale.title}</Styles.Title>

      <Styles.Description>{logoBuilderLocale.description}</Styles.Description>

      <Styles.ChoosePlan>{logoBuilderLocale.choosePlan}</Styles.ChoosePlan>

      <Styles.PlanCards>
        <Styles.Card free>
          <Styles.CardTitle free>
            {logoBuilderLocale.freePlan}
          </Styles.CardTitle>
          <Styles.Price free>
            {logoBuilderLocale.free}
          </Styles.Price>
          <Styles.CardDescription free>
            {logoBuilderLocale.freePlanDescription}
          </Styles.CardDescription>
          <Button variant="secondary" label={logoBuilderLocale.continueWithFree} size="medium2" onClick={() => handlePlanSelection(PLANS.FREE)} />
          {logoBuilderLocale.freeSpecs.map(spec => (
            <Styles.PlanSpec free key={spec}>
              <IconCircleCheck color="activeLight" size="sm" />
              {spec}
            </Styles.PlanSpec>
          ))}
        </Styles.Card>

        <Styles.Card>
          <Styles.CardTitle>
            {logoBuilderLocale.paidPlan}
          </Styles.CardTitle>
          <Styles.Price>
            {logoBuilderLocale.paidPlanPrice}
          </Styles.Price>
          <Styles.YearlyPrice>
            {logoBuilderLocale.yearlyPrice}
          </Styles.YearlyPrice>
          <Styles.CardDescription>
            {logoBuilderLocale.paidPlanDescription}
          </Styles.CardDescription>
          <Button label={logoBuilderLocale.startNow} size="large" width="full" onClick={() => handlePlanSelection(PLANS.PAID)} />
          {logoBuilderLocale.paidSpecs.map(spec => (
            <Styles.PlanSpec key={spec}>
              <IconCircleCheck color="activeLight" size="sm" />
              {spec}
            </Styles.PlanSpec>
          ))}
        </Styles.Card>
      </Styles.PlanCards>

      {modalToShow === MODALS.PAID_PLAN && (
        <ModalPaidPlan setSelectedPaidPlan={setSelectedPaidPlan} setModalToShow={setModalToShow} />
      )}

      {modalToShow === MODALS.LOGO_GENERATION && (
        <ModalLogoGeneration {...modalLogoGenerationProps()} />
      )}

      {(logoGenerated || modalToShow === MODALS.LOGO_SEND) && (
        <LogoBuilderSuccessModal {...logoBuilderSuccessModalProps()} />
      )}
    </Styles.Container>
  );
};


export default LogoBuilderHandler;
